import styled from 'styled-components';
import { Box } from 'theme';

export const DashboardWrapper = styled(Box)`
  background-color: ${({ theme }) => theme.palette.background.default};
  height: 100vh;
  overflow: auto;
`;
